import 'isomorphic-fetch';
import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';

import { Headers } from '@/types/types';
import { getConfig } from '@/constants';

const dynamicBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, WebApi, extraOptions) => {
  const baseUrl = `${getConfig().LOTVISION_URL}`;
  const rawBaseQuery = fetchBaseQuery({
    baseUrl,
    prepareHeaders: async (headers) => {
      headers.set(Headers.Accept, 'application/json');
      return headers;
    },
  });

  return rawBaseQuery(args, WebApi, extraOptions);
};

export const apiBase = createApi({
  reducerPath: 'api',
  // All of our requests will have URLs starting with '/ur/api/v1'
  baseQuery: dynamicBaseQuery,
  // The "endpoints" represent operations and requests for this server
  endpoints: () => ({}),
});
